import { EventEmitter } from 'eventemitter3';
import Worker from 'web-worker';
import { Env } from '../../Env';
import { createWorker } from '../../utils/workerUtils';
export class BroadcasterPreviewCanvas extends EventEmitter {
    canvas;
    worker;
    isWorkerReady = false;
    setCanvas(canvas) {
        // If setting the same canvas, don't transfer again
        if (this.canvas === canvas) {
            console.log('BroadcasterPreviewCanvas.setCanvas: same canvas, skipping transfer');
            return;
        }
        // Clean up previous worker
        if (this.worker) {
            this.worker.postMessage({
                type: 'destroy',
            });
            this.worker.terminate();
            this.worker = undefined;
            this.isWorkerReady = false;
        }
        this.canvas = canvas;
        if (canvas) {
            // Create worker
            if (Env.BUILD_TRANSFORMS_FILENAMES) {
                this.worker = new Worker(new URL('./workers/previewrenderer.worker.ts', import.meta.url));
            }
            else {
                this.worker = createWorker('./workers/previewrenderer.worker.js', import.meta.url);
            }
            this.worker.onmessage = (e) => {
                const { type } = e.data;
                switch (type) {
                    case 'ready':
                        this.isWorkerReady = true;
                        console.log('BroadcasterPreviewCanvas: worker ready');
                        break;
                    case 'frameRendered':
                        this.emit('frameRendered', e.data.videoFrame);
                        break;
                }
            };
            const offscreen = canvas.transferControlToOffscreen();
            this.worker.postMessage({
                type: 'setCanvas',
                canvas: offscreen,
            }, [offscreen]);
            console.log('BroadcasterPreviewCanvas.setCanvas: canvas transferred to worker');
        }
    }
    renderVideoFrame(frame) {
        if (!this.worker || !this.isWorkerReady) {
            console.warn('BroadcasterPreviewCanvas.renderVideoFrame: worker not ready');
            frame.close();
            return;
        }
        this.worker.postMessage({
            type: 'renderFrame',
            videoFrame: frame,
        }, [frame]);
    }
    destroy() {
        if (this.worker) {
            this.worker.postMessage({
                type: 'destroy',
            });
            this.worker.terminate();
            this.worker = undefined;
        }
        this.canvas = undefined;
        this.isWorkerReady = false;
    }
}
